<ion-header translucent>
  <ion-toolbar>
    <ion-title>{{ 'Mobile.DisengageTitle' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item-divider sticky>
      <ion-label class="ion-text-wrap title">
        <h2>{{ callcard.title }}</h2>
      </ion-label>
    </ion-item-divider>
    <ion-item (click)="onPeopleCountClicked()">
      <ion-label>
        <h2>
          <strong>{{ 'Mobile.Disengaged' | translate }}</strong>
        </h2>
        <h3>{{ peopleCount | number: '2.0-0' }}</h3>
      </ion-label>
      <ion-icon slot="end" name="caret-down-outline"></ion-icon>
    </ion-item>
  </ion-list>
</ion-content>

<ion-footer>
  <ion-button (click)="onDismiss()" color="danger">{{ 'Mobile.Cancel' | translate }}</ion-button>
  <ion-button (click)="onSubmit()" color="primary">{{ 'Mobile.Confirm' | translate }}</ion-button>
</ion-footer>
